module.exports = __webpack_public_path__ + "img/play-button.5753793d.png";